import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

const PortDetailPanel = ({ selectedPort, onClose }) => {
  if (!selectedPort) return null;

  const connected = selectedPort.connected_portregistry;
  const connectedPort =
    connected && typeof connected === 'object' ? connected : null;

  return (
    <Card
      className="port-detail-panel"
      size="small"
      title="Port Details"
      extra={
        <a onClick={onClose} role="button" tabIndex={0}>
          Close
        </a>
      }
      style={{ marginTop: 16, marginBottom: 16 }}
    >
      <div style={{ fontSize: 13, lineHeight: 1.8 }}>
        <div>
          <Text strong>Interface:</Text> {selectedPort.interface}
        </div>
        {selectedPort.description && (
          <div>
            <Text strong>Description:</Text> {selectedPort.description}
          </div>
        )}
        {selectedPort.datadrop && (
          <div>
            <Text strong>Data Drop:</Text> {selectedPort.datadrop}
          </div>
        )}
        {connectedPort && (
          <div>
            <Text strong>Connects to:</Text> {connectedPort.interface}
            {connectedPort.datadrop ? ` (${connectedPort.datadrop})` : ''}
          </div>
        )}
        {selectedPort.connection_note && (
          <div>
            <Text strong>Connection note:</Text> {selectedPort.connection_note}
          </div>
        )}
      </div>
    </Card>
  );
};

export default PortDetailPanel;
